import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, MessageCircle, Mail, MapPin } from "lucide-react";
import { NAV, SOCIALS, EMAIL, ADDRESS_1, ADDRESS_2, HOURS, WA_KARINA, wa } from "@/lib/site";
import { WaveMark } from "@/components/Illustrations";

const socialIcon = (name) =>
  name === "Instagram" ? <Instagram size={16} /> : name === "TikTok" ? <Music2 size={16} /> : <Facebook size={16} />;

const Footer = () => (
  <footer className="bg-ink text-cream border-t border-gold/20" data-testid="main-footer">
    <div className="px-6 sm:px-12 lg:px-20 pt-16 lg:pt-24 pb-10">
      <div className="flex flex-col lg:flex-row justify-between gap-14">
        <div className="max-w-md">
          <img
            src="/images/logo-light.png"
            alt="Karina Méndez Studio"
            data-testid="footer-wordmark"
            className="h-32 lg:h-36 w-auto"
          />
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-gold mt-4">La Gomera · Islas Canarias</p>
          <WaveMark className="w-28 text-gold/60 mt-8" />
          <p className="text-sm text-cream/60 mt-6 leading-relaxed">
            Cejas y labios con criterio. Técnica NAGI — resultados naturales y comprobados, no un tatuaje.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-10 text-sm">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mb-5">Menú</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <Link to={n.to} data-testid={`footer-link-${n.id}`} className="text-cream/70 hover:text-gold transition-colors duration-300">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mb-5">Contacto</p>
            <ul className="space-y-3 text-cream/70">
              <li>
                <a href={wa(WA_KARINA, "Hola Karina, quiero información.")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 hover:text-gold transition-colors duration-300">
                  <MessageCircle size={14} className="text-gold" /> +34 691 536 518
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="inline-flex items-center gap-2 hover:text-gold transition-colors duration-300 break-all">
                  <Mail size={14} className="text-gold shrink-0" /> {EMAIL}
                </a>
              </li>
              <li className="flex gap-2">
                <MapPin size={14} className="text-gold shrink-0 mt-1" />
                <span>
                  {ADDRESS_1}
                  <br />
                  {ADDRESS_2}
                </span>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mb-5">Horario</p>
            <ul className="space-y-3 text-cream/70">
              {HOURS.map(([d, h]) => (
                <li key={d}>
                  <span className="text-cream">{d}</span>
                  <br />
                  {h}
                </li>
              ))}
            </ul>
            <div className="flex gap-3 mt-6">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.name}
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  className="w-9 h-9 rounded-full border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors duration-300"
                >
                  {socialIcon(s.name)}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-gold/15 flex flex-col sm:flex-row justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40">
        <span data-testid="footer-copy">© {new Date().getFullYear()} Karina Méndez Studio</span>
        <span className="flex gap-6">
          <Link to="/aviso-legal" data-testid="footer-legal-aviso" className="hover:text-gold transition-colors duration-300">Aviso legal</Link>
          <Link to="/privacidad" data-testid="footer-legal-privacidad" className="hover:text-gold transition-colors duration-300">Privacidad</Link>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
